import Vue from 'vue'
import Vuetify, { VSnackbar, VBtn, VIcon } from 'vuetify/lib'
import i18n from '@/i18n'
import '@/sass/overrides.sass'
import 'chartist/dist/chartist.min.css'
import 'chartist-plugin-tooltips-updated/dist/chartist-plugin-tooltip.css';
import VuetifyToast from 'vuetify-toast-snackbar-ng'

Vue.use(Vuetify, {
 components: {
  VSnackbar, VBtn, VIcon,
},
},
)

const theme = {
  primary: '#157EFB',
  secondary: '#9C27b0',
  accent: '#9C27b0',
  info: '#00CAE3',
}

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
})

Vue.use(VuetifyToast, { color: 'green' })
